import base from './baseApi';
import { TouristCenterOverrideType, CreateTouristCenterOverrideDto, UpdateTouristCenterOverrideDto } from 'src/types/touristCenterOverride';

const { urls, methods, execute } = base();

interface GetTouristCenterOverridesParams {
  searchQuery?: string;
}

export const getTouristCenterOverrides = (params: GetTouristCenterOverridesParams) => {
  const url = urls.touristCenterOverrides.list;
  return execute(methods.GET, url, { authorization: true }, params);
};

export const createTouristCenterOverride = (payload: CreateTouristCenterOverrideDto) => {
  const url = urls.touristCenterOverrides.list;
  return execute(methods.POST, url, { authorization: true }, payload);
};

export const updateTouristCenterOverride = (
  overrideId: string,
  payload: UpdateTouristCenterOverrideDto
) => {
  const url = `${urls.touristCenterOverrides.list}/${overrideId}`;
  return execute(methods.PUT, url, { authorization: true }, payload);
};

export const deleteTouristCenterOverride = (overrideId: string) => {
  const url = `${urls.touristCenterOverrides.list}/${overrideId}`;
  return execute(methods.DELETE, url, { authorization: true });
};
